// extracted by mini-css-extract-plugin
module.exports = {"input":"FormLeft_input__3M2yA","label":"FormLeft_label__2hY41"};